﻿$(document).ready(function () {
    sethtmlData();
})

function sethtmlData() {
    $.ajax({
        url: "header_last.html",
        async: true,
        success: function (data) {
            $('.header_content').html(data);
        }
    });
    $.ajax({
        url: "footer.html",
        async: true,
        success: function (data) {
            $('.footer_content').html(data);
        }
    });
   
}




///////////////////////////////// методы обмена данными /////////////////////////////////

//парсит параметры с формы ввода в обьект
// inputs: formCaption - id формы без #
// outputs: [{name: "key", value: "text:param"},
//          {name: "key", value: "param"}]
function formToObj(formCaption) {
    const arr = ['select', 'input'];
    var rezArr = [];

    for (var i = 0; i < arr.length; i++) {
        var $objArr = $('#' + formCaption).find(arr[i]);
        for (var j = 0; j < $objArr.length; j++) {
            var $item = $($objArr[j]);
            if ($item.attr('name') != undefined) {
                var rezObj = {};
                let value = checkVal($item);
                if (typeof (value) === 'object') {
                    value.forEach(function (item) {
                        rezArr.push(item);
                    })
                }
                else {
                    if (checkVal($item) != "") {
                        rezObj.name = $item.attr('name');
                        rezObj.value = checkVal($item);

                        rezArr.push(rezObj);
                    }
                }
            }
        }
    }
    return rezArr;
 function checkVal($item) {
        let value = $item.val();

        if (value) {

            switch ($item.prop('tagName')) {
                case 'INPUT':
                    if ($item.attr('type') === 'checkbox') {
                        if ($item.prop("checked"))
                            return 'on';
                        else return '';
                    }
                    else return value;
                    break;
                case 'SELECT':
                    let arr = [];
                    let obj = $('#' + $item.attr('id') + ' option:selected');
                    for (let i = 0; i < obj.length; i++) {
                        let item = obj[i];
                        let rez = {};
                        rez.name = $item.attr('name');
                        rez.value = item.text + ':' + item.value;
                        arr.push(rez);
                    }
                    return arr
                    break;
            }
        }
        else
            return '';
    }
}

// выделяет обьекты с множественным выбором 
// outputs {key:["param", "param"]}
function setDataMulticontrol(iArr, rezObj) {
    let iArrKey = Object.keys(rezObj);
    let data = {};
    $.each(iArrKey, (indexKey, valueKey) => {
        let TArr = [];
        $.each(iArr, (index, val) => {
            let name = val.name;
            if (name.indexOf(valueKey) > -1) {
                let Tval = val.value;
                TArr.push(Tval);
            }
        })
        if (TArr.length > 1)
            data[valueKey] = TArr;

    })
    return data;
}

// перевод параметров с формы в url
export function dataFormToURL(formСaption) {
    var localName = location.pathname.split('/');
    if (localName.length > 1)
        localName.splice(0, localName.length - 1);

    var rezStrSt = localName + '?';

    var rezStr = '';
    var formParam = formToObj(formСaption);

    let sentObj = {};
    $.each(formParam, (index, val) => {
        let vl = val.value;
        sentObj[val.name] = vl;
    })
    sentObj["PageSize"] = "10";
    sentObj["Sort"] = "0";

    let multiData = setDataMulticontrol(formParam, sentObj);

    $.each(sentObj, (key, value) => {
        sentObj[key] = (multiData[key] == undefined ? sentObj[key] : multiData[key]);
    })

    $.each(sentObj, (key, val) => {
        rezStr += '&' + key + '=' + arrToStr(val);
    })
    history.pushState('', document.title, rezStrSt + rezStr.substr(1));
}

function arrToStr(arr) {
    let str = '';
    if (typeof (arr) == 'object') {
        arr.forEach((value, index, arr) => {
            str += ';' + value;
        })
        return str.substr(1);
    }
    else return arr;

}

// перевод параметров url в обьект для отправки на сервер или для заполнения контролов
//cntrl = false для ajax
//cntrl = true для заполнения конролов
export function urlToObj(cntrl) {
    let url = decodeURIComponent(location.search);
    var queryStart = url.indexOf("?") + 1,
        queryEnd = url.indexOf("#") + 1 || url.length + 1,
        query = url.slice(queryStart, queryEnd - 1),
        data = {},
        nv,
        k,
        v,
        pairs = query.replace(/\+/g, " ").split("&");
    if (query === url || query === "") {
        return data = null;
    }
    for (let i = 0; i < pairs.length; i++) {
        nv = pairs[i].split("=");
        k = decodeURIComponent(nv[0]);
        v = decodeURIComponent(nv[1]) == "on" ? true : decodeURIComponent(nv[1]);
        if (v != "" && v != undefined) {
            let tv = parseUrlToArr(v, cntrl);
            data[k] = tv;
        }
    }
    return data;
}

function parseUrlToArr(iStr, cntrl) {
    let Tarr = iStr.split(';');
    let Rarr = [];
    if (Tarr.length > 1) {
        Tarr.forEach((value, index, Tarr) => {
            if (!cntrl)
                Rarr[index] = value.split(':')[1];
            else {
                let Tobj = {};
                Tobj.k = value.split(':')[1];
                Tobj.v = value.split(':')[0];
                Rarr[index] = Tobj;
            }

        })
        return Rarr;
    }
    else {
        let Tval = Tarr[0];
        if (Tval.split(':').length > 1) {
            if (!cntrl)
                return Tval.split(':')[1];
            else {
                let Tobj = {};
                Tobj.k = Tval.split(':')[1];
                Tobj.v = Tval.split(':')[0];
                return Tobj;
            }
        }
        else
            return Tval;
    }
}


///////////////////////////////// Анимация /////////////////////////////////

// - функция запуска анимации
export function startLoadingAnimation() {
    $(window).scrollTop(0);

    $('body').append(`
<div id = "loadingImgContainer">
    <div id="loadImg"></div>
</div>
    `)
}

// - функция остановки анимации
export function stoptLoadingAnimation() {
    $("#loadingImgContainer").remove();
}


///////////////////////////////// AJAX /////////////////////////////////
// inputs: captionFunc - заголовок функции к которой обращаемся
//         sendObj - обьект который передаем(без JSON)
export function sentAjaxTo(captionFunc, sendObj) {
    let sendJSON = JSON.stringify(sendObj);
    startLoadingAnimation();
    $.ajax({
        type: "Post",
        url: "./ASPWebDataServise.asmx/" + captionFunc,
        data: "{inputsParam:'" + sendJSON + "'}",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function (response) {
            let resp = JSON.parse(response.d)
            switch (captionFunc) {

                case 'GetListChildren':
                    var main = require('./main.js');
                    main.setDataListOrg(resp);
                    break;
                case 'CheckChildInList':
                    var main_ = require('./main.js');
                    main_.setResultInfo(resp);
                    break;
                case 'GetChildrenBasicInfo':
                    var info = require('./info.js');
                    info.setBasicInform(resp);
                    break;
            }
            stoptLoadingAnimation();
        },
        error: function (response) {
            alert('Error to sent data :(');
            stoptLoadingAnimation();
        }
    });

}






//////////////////
// WEBPACK FOOTER
// ./js/core.js
// module id = 0
// module chunks = 0 1 2